import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  FormGroup,
  FormControl,
  Spinner,
  EmptyState,
  ControlLabel
} from 'modules/theme';
import { Modal } from 'react-bootstrap';
import { Column, Columns, DataWrapperClass, Title } from '../styles/main';
import { ModalFooter, CenterContent } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
import { Alert } from 'modules/common/utils';
import Icon from './Icon';

const contextTypes = {
  __: PropTypes.func
};

class ChooserSelector extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.save = this.save.bind(this);
    this.renderNonSelected = this.renderNonSelected.bind(this);
    this.search = this.search.bind(this);
    this.itemSelected = this.itemSelected.bind(this);
    this.mAPI = new APIManager();
    this.timer = '';
    this.actualList = [];
    this.state = {
      isAdded: false,
      showHide: false,
      search: '',
      selectedLoader: false,
      nonSelectedLoader: false,
      elementId: props.elementId,
      selected: [],
      list: []
    };
  }
  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.elementId !== this.state.elementId) {
      this.setState({ elementId: nextProps.elementId });
      // console.log('element Id Updated', nextProps.elementId);
      if (nextProps.elementId != '') {
        this.selectedElements(nextProps.elementId);
      }
    }
  }

  componentWillUnmount() {
    // this.props.clearState();
  }

  handleModal() {
    this.setState({
      showHide: !this.state.showHide
    });
  }

  closeModal() {
    // console.log('closeModal');
    this.setState({ showHide: false });
  }
  openModal() {
    this.setState({ showHide: true });
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }
  handleChange(type, data) {
    const { selected, list } = this.state;
    let _this = this;
    if (type === 'add') {
      // if ( this.props.limit && this.props.limit === datas.length) {
      //   return;
      // }
      let list = [];
      try {
        list = this.state.list.filter(el => {
          return el._id !== data._id;
        });
      } catch (error) {
        console.log(`List update error`);
      }
      this.setState({ selected: [data, ...selected], list: list });
    } else {
      this.setState({
        selected: selected.filter(item => item !== data),
        list: [data, ...list]
      });
    }
    setTimeout(()=>{
      _this.itemSelected();
    },200)
  }
  renderRow(data, icon) {
    // console.log('DataRow', data);
    if (icon === 'add' && this.state.selected.some(e => e._id === data._id)) {
      return null;
    }

    return (
      <li key={data._id} onClick={() => this.handleChange(icon, data)}>
        {data.name}
        <Icon icon={icon} />
      </li>
    );
  }
  renderNonSelected(list) {
    if (this.state.nonSelectedLoader) {
      return <Spinner />;
    } else if (list.length) {
      return <ul>{list.map(data => this.renderRow(data, 'add'))}</ul>;
    }
    return <EmptyState text="No items" icon="list-2" />;
  }
  renderSelected(selected) {
    if (this.state.selectedLoader) {
      return <Spinner />;
    } else if (selected.length) {
      return (
        <ul>{selected.map(data => this.renderRow(data, 'minus-circle'))}</ul>
      );
    }
    return <EmptyState text="No items added" icon="list-2" />;
  }

  render() {
    const { __ } = this.context;
    const { showHide = false, modalSize = 'lg' } = this.props;
    return (
      <Modal size={modalSize} show={this.state.showHide}>
        <Modal.Body>
          <form onSubmit={e => this.save(e)}>
            <Columns>
              <Column>
                <FormControl
                  placeholder={'Type to search'}
                  onChange={this.search}
                />
                <ul>{this.renderNonSelected(this.state.list)}</ul>
              </Column>
              <Column>
                <Title>
                  Responders
                  <span>{this.state.selected.length}</span>
                </Title>
                {this.renderSelected(this.state.selected)}
              </Column>
            </Columns>
            <ModalFooter>
              { !this.state.isAdded && <p className="text-danger" style={{"textAlign":"right"}}>We didn't found any changes in mapping</p>}
              <Button
                btnStyle="cancel"
                onClick={() => this.handleModal()}
                size="xl"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                btnStyle="default"
                size="xl"
                style={{ float: 'right' }}
              >
                Update
              </Button>
            </ModalFooter>
            {/* <ModalFooter>
              <Button
                btnStyle="simple"
                onClick={() => this.handleModal()}
                icon="cancel-1"
                size="small"
                style={{ marginRight: '10px' }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                btnStyle="default"
                icon="checked-1"
                size="small"
              >
                Select
              </Button>
            </ModalFooter> */}
          </form>
        </Modal.Body>
      </Modal>
    );
  }
  apiResponse(errorCode, data) {
    // console.log('Error Code', errorCode);
    if (errorCode === 0) {
      let message = 'File Successfully Updated.';
      data && data.message ? data.message : 'Successfully updated';
      Alert.success(`${message}`);
      this.closeModal();
    } else {
      let message = data && data.message ? data.message : 'Upload Error';
      Alert.error(`${message}`);
    }
  }
  nonSelectedElements(selected, searchText = '', elementId) {
    this.setState({ nonSelectedLoader: true });
    var that = this;
    let { searchUrl = '', searchProcess } = this.props;

    selected.map(data => {
      searchUrl += '&excluded=' + data._id;
    });
    if (searchText) {
      searchUrl += '&search=' + searchText;
    }
    searchUrl = searchUrl.replace('<elementId>', elementId);

    this.mAPI.sendGetAPI(
      searchUrl,
      data => {
        let list = [];
        if (typeof searchProcess === 'function') {
          list = searchProcess(data);
        }
        if (list) {
          that.setState({ list: list, nonSelectedLoader: false });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        this.setState({ nonSelectedLoader: false, list: [] });
        if (data && data.message ) {
          Alert.error(`${error} : ${data.message}`);
        } else {
          Alert.error(`Something Wrong Happened!!`);
        }
      }
    );
  }
  selectedElements(elementId) {
    this.setState({
      selectedLoader: true,
      nonSelectedLoader: true,
      showHide: true
    });
    var that = this;
    let { selectedUrl = '', selectedProcess } = this.props;
    this.actualList = [];
    if( selectedUrl ){

      selectedUrl = selectedUrl.replace('<elementId>', elementId);
      this.mAPI.sendGetAPI(
        selectedUrl,
        data => {
          this.setState({ selectedLoader: false });
          // console.log(JSON.stringify(data, null, 2));
          let list = [];
          if (typeof selectedProcess === 'function') {
            list = selectedProcess(data);
          }
          if (list) {
            this.actualList = list;
            that.setState({ selected: list });
          }
          this.nonSelectedElements(list,"",elementId);
        },
        (error, data) => {
          // this.setState({"selectedLoader":false});
          // console.log(`Error:`, error);
          this.setState({
            nonSelectedLoader: false,
            selectedLoader: false,
            selected: []
          });
          // if (data) {
          //   Alert.error(`${error} : ${data.message}`);
          // } else {
          //   Alert.error(`${error}`);
          // }
        }
      );
    } else {
      let list = []
      if (list) {
        this.actualList = list;
        that.setState({ selected: list, selectedLoader: false });
      }
      this.nonSelectedElements(list,"",elementId);
    }
  }
  itemSelected() {
    let added = [],
        removed = [];
    this.actualList.map(data => {
      if (!this.state.selected.some(e => e._id === data._id)) {
        removed.push(data._id);
      }
    });
    this.state.selected.map(data => {
      if (!this.actualList.some(e => e._id === data._id)) {
        added.push(data._id);
      }
    });

    if( added.length ||  removed.length ){
      this.setState({"isAdded":true})
    } else {
      this.setState({"isAdded":false})
    }
    console.log("itemSelected");
  }
  save(e) {
    /* prevent the result */
    e.preventDefault();

    let _this = this;
    let { finalUrl = '', fetchData, elementId } = this.props;
    finalUrl = finalUrl.replace('<elementId>', elementId);

    /* */
    let added = [],
      removed = [];

    this.actualList.map(data => {
      if (!this.state.selected.some(e => e._id === data._id)) {
        removed.push(data._id);
      }
    });
    this.state.selected.map(data => {
      if (!this.actualList.some(e => e._id === data._id)) {
        added.push(data._id);
      }
    });
    let formData = fetchData(added, removed);

    this.mAPI.sendPostAPI(
      `${finalUrl}`,
      formData,
      data => {
        //Set the progress value to show the progress bar
        // console.log('Upload progress', data);
        // console.log(JSON.stringify(data, null, 2));
        Alert.success(`Updated Successfully.`);
        this.closeModal();
        // this.handleModalShowImport();
        // this.resetAllData();
        // this.getList();
      },
      (errorCode, data) => {
        this.apiResponse(errorCode, data);
      },
      'private',
      {},
      'PUT'
    );
  }
  search(e) {
    let value;
    value = e.target.value;
    // console.log('search', e.target.value);
    const _this = this;
    if (_this.timer) clearTimeout(_this.timer);
    _this.timer = setTimeout(() => {
      _this.setState({ search: value });
      _this.nonSelectedElements(this.state.selected, this.state.search, this.state.elementId);
    }, 500);
  }
}

ChooserSelector.contextTypes = contextTypes;

export default ChooserSelector;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/ChooserSelector.js